(function Module() {
	'use strict';
	
  var mySynchModules = require('../config');
	var config = mySynchModules.config;
	mySynch.controller('SeasonalTrendsController', [
		'$scope',
		'$rootScope',
    '$window',
		'ApiFactory',
		'AuditService',
		'F360Constant',
		'MySynchFactory',
		'$interval',
		'$filter',
	  '$q',
    '$http',
    '$sce',
		'ViewAuthorizationFactory',
    '$timeout',
    'performanceMetricsService',
    'performanceContextService',
    'clientLoggerService',
		function SeasonalTrendsController($s,$rootScope,$window, api, audit, constant, MSF, $interval,$filter,$q,$http,$sce,viewAuth,$timeout, perfMetricSvc, perfContextSvc, log) {

            $s.performanceContext = null;
            $s.loading = false;
            $s.reportLoading = false;
            $s.refreshCheckInProgress = false;
            const showVegaEditor = false;
            $s.envName = MSF.getEnvironmentName();
            let pythonServicesFunctionUrl = "";

            //TODO: refactor this variable to get the array from codefile 
            $s.pageViewBetaReq = ["Seasonal"];
            $s.canViewPage = true;

            $s.currentActiveHerd = MSF.getActiveHerd();
            $s.currentActiveFarm = MSF.getActiveFarm();
            $s.territoryManager  = MSF.getActiveFarmTerritoryManager(); 

            $s.checkPermissions = function checkPermissions(){
            $s.canViewPage = false;


                if(!_.isUndefined($s.currentActiveFarm) && !_.isNull($s.currentActiveFarm) && !_.isEmpty($s.currentActiveFarm)){
                  var herds = _.get($s.currentActiveFarm,'herds',[]);
                  if(!_.isEmpty(herds)){
                       var hasHerdWithDC305 = _.any(herds,{herdMgmtSoftware: "DC305"});
                        if(!hasHerdWithDC305){
                          MSF.loadPage("User");
                        }
                      }

                }

             
               if(_.isEqual(_.get($s.currentActiveFarm,'allowSeasonalTrends'),true)){
                $s.canViewPage = true;
              }
            };

            $s.originalPythonSpecWithData = {};

            $s.chartSpec_lg      = {};
            $s.chartSpec_sm      = {};

            // --- Each data set ---
            $s.dataLact1   = {};
            $s.dataLact2   = {};
            $s.dataLactAll = {};

            $s.chartWidth_lg  = 1000;
            $s.chartWidth_sm  = 180;

            // chart views
            $s.currentLargeChartView =  {};
            $s.sm_chart_lactation_all_view = {};
            $s.sm_chart_lactation1_view = {};
            $s.sm_chart_lactation2_view = {};
	
            // -- TODO: Get this all from dbo.CodeFile ---
            $s.fertilityRateItems= [{code: 'PregRate',    name:'Pregnancy Rate (21 day)'          , rhaname:'RhaPreg'    },
                                    {code: 'InsemRate',   name:'Insemination Rate (21 day)'       , rhaname:'RhaInsem'   },
                                    {code: 'ConcepRate',  name:'Conception Rate (21 day)'         , rhaname:'RhaConcep'  }
                                   ];

            // -- TODO: Get this all from dbo.CodeFile ---
            $s.fertilityRhaRateItems= [{code: 'PregRate',    rhaname:'RhaPreg'    },
                                       {code: 'InsemRate',   rhaname:'RhaInsem'   },
                                       {code: 'ConcepRate',  rhaname:'RhaConcep'  },
                                       {code: 'RhaPreg',     rhaname:'RhaPreg'    },
                                       {code: 'RhaInsem',    rhaname:'RhaInsem'   },
                                       {code: 'RhaConcep',   rhaname:'RhaConcep'  }
                                      ];
                                    
            $s.opt  = {};
            $s.opt.fertilityRateSelected    = 'PregRate';
            $s.opt.fertilityRhaRateSelected = 'RhaPreg';
            $s.opt.show21dayDots         = false;
            $s.opt.showStdErrorShade     = false;
            $s.opt.trendSensitivity      = "0.35";
            $s.opt.lactSelected          = 3;
            $s.opt.lactSelectedDesc      = 'All Lactations';


            var dt = MSF.activeHerd.latestReportDate;
			      $s.dataUpdatedDate = moment(dt).subtract(moment(dt).utcOffset(), 'minutes').format(MSF.i18n.format.dateLong);

            var deregOnHerdChange = undefined;

            function setPythonFunctionUrl(){
              switch($s.envName){
                case "PROD":
                    pythonServicesFunctionUrl = "https://mysynchpythonservices-functionprod.azurewebsites.net/api/SeasonalChartsTrigger?code=ThJ6LN-6fR2ygLD1E_G2gKwrHeY_rlqvlaW9CrjvChYsAzFuFRua9Q==";
                    break;
                 case "STAGE":
                    pythonServicesFunctionUrl = "https://mysynchpythonservices-functionstage.azurewebsites.net/api/SeasonalChartsTrigger?code=uETFeqYr8jto32KmXI0vzqz8I7-J8hievZuGjcPuSBztAzFuMAWBHA=="
                    break;
                 case "TEST":
                    pythonServicesFunctionUrl = "https://mysynchpythonservices-functiontest.azurewebsites.net/api/SeasonalChartsTrigger?code=LP1BwB9LAdTrM5O5pJ7G0oUSBhHKTS7AzPy3KGe4fTmBAzFurt8q7g==";
                    break;
                 case "DEV": 
                    pythonServicesFunctionUrl = "https://mysynchpythonservices-functiondev.azurewebsites.net/api/SeasonalChartsTrigger?code=ecz-dbIyu-wnDNo6OrlH6M7N2EnQNa8C6tsLbSkQLPWwAzFuHjWSng==";
                    break;
                 default: 
                    pythonServicesFunctionUrl = "https://mysynchpythonservices-functionstage.azurewebsites.net/api/SeasonalChartsTrigger?code=uETFeqYr8jto32KmXI0vzqz8I7-J8hievZuGjcPuSBztAzFuMAWBHA=="
                    break;
            }
          }

            $s.startStopSpinner = function startStopSpinner(){
                $s.loading = !$s.loading;
            };
            
            $s.buildAndEmbedReports = function buildAndEmbedReports(){

              // --- Gather chart and data from API

              $s.chartSpec_lg = _.cloneDeep($s.originalPythonSpecWithData);

// ----------------------------------------------------------------------              
// --- MySynch changes to be made in the Python code:
$s.chartSpec_lg = _.omit($s.chartSpec_lg, 'width');

_.set(   $s.chartSpec_lg, 'autosize'  , "pad");
var width_index_lg     = _.findIndex($s.chartSpec_lg.signals, {name:'width'});
_.set($s.chartSpec_lg,'signals['+width_index_lg+'].init', "containerSize()[0] * 0.85" );
_.set($s.chartSpec_lg,'signals['+width_index_lg+'].on[0].update', "containerSize()[0] * 0.85" );
// --- adjust lines ---
var wh_m0 = _.findIndex($s.chartSpec_lg.marks,  {name:'mark_loess_year_0'});
var wh_m1 = _.findIndex($s.chartSpec_lg.marks,  {name:'mark_loess_year_1'});
var wh_m2 = _.findIndex($s.chartSpec_lg.marks,  {name:'mark_loess_year_2'});
var wh_m3 = _.findIndex($s.chartSpec_lg.marks,  {name:'mark_loess_year_3'});
_.set(  $s.chartSpec_lg,  'marks[' + wh_m0 + '].encode.update.width',       {"signal": 'width'});
_.set(  $s.chartSpec_lg,  'marks[' + wh_m1 + '].encode.update.width',       {"signal": 'width'});
_.set(  $s.chartSpec_lg,  'marks[' + wh_m2 + '].encode.update.width',       {"signal": 'width'});
_.set(  $s.chartSpec_lg,  'marks[' + wh_m3 + '].encode.update.width',       {"signal": 'width'});
_.set(  $s.chartSpec_lg,  'marks[' + wh_m0 + '].encode.update.strokeWidth', {"signal": "width / (width >= 700 ? 240 : (width <= 400 ? 260 : 240))"});   // -- was 200
_.set(  $s.chartSpec_lg,  'marks[' + wh_m1 + '].encode.update.strokeWidth', {"signal": "width / (width >= 700 ? 270 : (width <= 400 ? 300 : 280))"});   // -- was 260
_.set(  $s.chartSpec_lg,  'marks[' + wh_m2 + '].encode.update.strokeWidth', {"signal": "width / (width >= 700 ? 270 : (width <= 400 ? 300 : 280))"});   // -- was 260
_.set(  $s.chartSpec_lg,  'marks[' + wh_m3 + '].encode.update.strokeWidth', {"signal": "width / (width >= 700 ? 290 : (width <= 400 ? 310 : 300))"});   // -- was 290

_.set(  $s.chartSpec_lg,  'marks[' + wh_m0 + '].encode.update.opacity',     ["width >= 700 ? 1.0 : (width <= 400 ? 0.8 : 1.0)"]);
_.set(  $s.chartSpec_lg,  'marks[' + wh_m1 + '].encode.update.opacity',     ["width >= 700 ? 0.9 : (width <= 400 ? 0.6 : 0.7)"]);
_.set(  $s.chartSpec_lg,  'marks[' + wh_m2 + '].encode.update.opacity',     ["width >= 700 ? 0.8 : (width <= 400 ? 0.6 : 0.7)"]);
_.set(  $s.chartSpec_lg,  'marks[' + wh_m3 + '].encode.update.opacity',     ["width >= 700 ? 0.7 : (width <= 400 ? 0.6 : 0.7)"]);

// --- adjust dots ---
wh_m0 = _.findIndex($s.chartSpec_lg.marks,    {name:'mark_dots_0'});
wh_m1 = _.findIndex($s.chartSpec_lg.marks,    {name:'mark_dots_1'});
wh_m2 = _.findIndex($s.chartSpec_lg.marks,    {name:'mark_dots_2'});
wh_m3 = _.findIndex($s.chartSpec_lg.marks,    {name:'mark_dots_3'});
_.set(  $s.chartSpec_lg,  'marks[' + wh_m0 + '].encode.update.width',    {"signal": 'width'   });
_.set(  $s.chartSpec_lg,  'marks[' + wh_m1 + '].encode.update.width',    {"signal": 'width'   });
_.set(  $s.chartSpec_lg,  'marks[' + wh_m2 + '].encode.update.width',    {"signal": 'width'   });
_.set(  $s.chartSpec_lg,  'marks[' + wh_m3 + '].encode.update.width',    {"signal": 'width'   });
_.set(  $s.chartSpec_lg,  'marks[' + wh_m0 + '].encode.update.height',   {"signal": 'height'  });
_.set(  $s.chartSpec_lg,  'marks[' + wh_m1 + '].encode.update.height',   {"signal": 'height'  });
_.set(  $s.chartSpec_lg,  'marks[' + wh_m2 + '].encode.update.height',   {"signal": 'height'  });
_.set(  $s.chartSpec_lg,  'marks[' + wh_m3 + '].encode.update.height',   {"signal": 'height'  });
_.set(  $s.chartSpec_lg,  'marks[' + wh_m0 + '].encode.update.size',     {"signal": "width/11"});
_.set(  $s.chartSpec_lg,  'marks[' + wh_m1 + '].encode.update.size',     {"signal": "width/14"});
_.set(  $s.chartSpec_lg,  'marks[' + wh_m2 + '].encode.update.size',     {"signal": "width/17"});
_.set(  $s.chartSpec_lg,  'marks[' + wh_m3 + '].encode.update.size',     {"signal": "width/20"});


var y_gridlines  = _.findIndex($s.chartSpec_lg.axes,     {name:'y_axis_gridlines'});
_.set(  $s.chartSpec_lg,  'axes[' + y_gridlines + '].tickCount',    {signal: 'ceil(width/125)'});

// --- MySynch changes to be made in the Python code:
// ----------------------------------------------------------------------              

              _.set($s.chartSpec_lg, 'usermeta.embedOptions.renderer',  "svg");
              _.set($s.chartSpec_lg, 'usermeta.embedOptions.actions', {source: false, compiled: false, editor: showVegaEditor});
              _.set($s.chartSpec_lg, 'usermeta.embedOptions.actions.tooltip', {theme: 'dark'});

              var wh_lact = _.findIndex($s.chartSpec_lg.signals,  {name:'lactation_signal'});
              _.set($s.chartSpec_lg, 'signals[' + wh_lact + '].bind', null);          // -- was unable to get _.remove to work. This probably gets the unable to bind to null error.
              
              // --- Small Charts
              $s.chartSpec_sm = _.cloneDeep($s.chartSpec_lg);

              _.set($s.chartSpec_sm, 'autosize'       , "fit");
              _.set($s.chartSpec_sm, 'background'       ,  "#EBEBEB");

              var x_axis  = _.findIndex($s.chartSpec_lg.axes,     {name:'x_axis'});
              var y_axis  = _.findIndex($s.chartSpec_lg.axes,     {name:'y_axis'});
              _.set($s.chartSpec_sm, 'axes[' + x_axis + '].labels',  false);
              _.set($s.chartSpec_sm, 'axes[' + x_axis + '].ticks' ,  false);
              _.set($s.chartSpec_sm, 'axes[' + y_axis + '].labels',  false);
              _.set($s.chartSpec_sm, 'axes[' + y_axis + '].ticks' ,  false);

              var width_index_sm     = _.findIndex($s.chartSpec_sm.signals, {name:'width'});
              _.set($s.chartSpec_sm,'signals['+width_index_sm+'].init', "clamp(containerSize()[0],60,249)" );
              _.set($s.chartSpec_sm,'signals['+width_index_sm+'].on[0].update', "clamp(containerSize()[0],60,249)" );

              _.set($s.chartSpec_sm, 'height' ,  {"signal": "width/1.15"});
              _.set($s.chartSpec_sm, 'data'   , _.get($s.chartSpec_lg,'data',[]));
              _.set($s.chartSpec_sm, 'legends',  []);
              _.set($s.chartSpec_sm, 'usermeta.embedOptions.actions', false);

             
              var dots_mark_index0 = _.findIndex($s.chartSpec_sm.marks, {name:'mark_dots_0'});
              _.set($s.chartSpec_sm,'marks['+dots_mark_index0+'].encode.update.tooltip', "" );
              
              var dots_mark_index1 = _.findIndex($s.chartSpec_sm.marks, {name:'mark_dots_1'});
              _.set($s.chartSpec_sm,'marks['+dots_mark_index1+'].encode.update.tooltip', "" );
              
              var dots_mark_index2 = _.findIndex($s.chartSpec_sm.marks, {name:'mark_dots_2'});
              _.set($s.chartSpec_sm,'marks['+dots_mark_index2+'].encode.update.tooltip', "" );

              var dots_mark_index3 = _.findIndex($s.chartSpec_sm.marks, {name:'mark_dots_3'});
              _.set($s.chartSpec_sm,'marks['+dots_mark_index3+'].encode.update.tooltip', "" );

              $s.dataLact2    = _.cloneDeep($s.chartSpec_sm);
              $s.dataLact1    = _.cloneDeep($s.chartSpec_sm);
              $s.dataLactAll  = _.cloneDeep($s.chartSpec_sm);

              // --- Filter Small Charts to individual buttons
              _.set($s.dataLact1   , 'signals[' + wh_lact + '].value',  1 );
              _.set($s.dataLact2   , 'signals[' + wh_lact + '].value',  2 );
              _.set($s.dataLactAll , 'signals[' + wh_lact + '].value',  3 );


              // --- Large Chart ---
              _.set($s.chartSpec_lg, 'height',  {"signal": "width/1.80"});
              _.set($s.chartSpec_lg, 'signals[' + wh_lact + '].value', $s.opt.lactSelected );

            };



            $s.toggleChartOptionOnChange       = function toggleChartOptionOnChange(toggleId){
                var desktopToggle = "#"+toggleId;
                var mobileToggle  = "#"+toggleId+"Mobile";

                var checked = $(desktopToggle).prop('checked');
                $(desktopToggle).prop('value', checked);
                // Toggle the hidden checkbox
                $(mobileToggle).click();
            }
            $s.toggleChartOptionOnChangeMobile = function toggleChartOptionOnChangeMobile(toggleId) {
                var desktopToggle = "#"+toggleId;
                var mobileToggle  = "#"+toggleId+"Mobile";

                var checked = $(mobileToggle).prop('checked');
                $(mobileToggle).prop('value', checked);
                // Toggle the hidden checkbox
                $(desktopToggle).click();
            }

            
            $s.changeFertilityRate        = function changeFertilityRate(id) {
              var desktopFertility = "#"+id;
              var mobileFertility  = "#"+id+"Mobile";

               $(mobileFertility).val($(desktopFertility).val());
            }
            $s.changeFertilityRateMobile  = function changeFertilityRateMobile(id) {
              var desktopFertility = "#"+id;
              var mobileFertility  = "#"+id+"Mobile";

              $(desktopFertility).val($(mobileFertility).val());
              $(desktopFertility)[0].dispatchEvent(new Event("input"));
            }


            $s.slideChartOptionOnChange       = function slideChartOptionOnChange(id) {
               var desktopSlide = "#"+id;
               var mobileSlide  = "#"+id+"Mobile";
              
              $(mobileSlide).val($(desktopSlide).val());
            }
            $s.slideChartOptionOnChangeMobile = function slideChartOptionOnChangeMobile(id) {
              var desktopSlide = "#"+id;
              var mobileSlide  = "#"+id+"Mobile";
              
              $(desktopSlide).val($(mobileSlide).val());
              $(desktopSlide)[0].dispatchEvent(new Event("input"));
            }


            $s.lactationOnChange = function lactationOnChange(lactNum, evnt) {
              evnt.preventDefault();
              $s.opt.lactSelected = lactNum;

              var wh_lact = _.findIndex($s.chartSpec_lg.signals, {name:'lactation_signal'});
              _.set($s.chartSpec_lg , 'signals[' + wh_lact + '].value', $s.opt.lactSelected );

              $s.opt.lactSelectedDesc = (lactNum==1 ? 'Lactation 1'   :
                                        (lactNum==2 ? 'Lactation 2+'  :
                                        (lactNum==3 ? 'All Lactations' : null)));

              var embed_large  = {actions: false, // {source: false, compiled: false, editor: showVegaEditor},
                                  tooltip: {theme: 'dark'} };

              vegaEmbed('#visSeasonalTrendsSelected', $s.chartSpec_lg , embed_large).then((result) => {
                $s.currentLargeChartView = result.view;
              });

              console.log("## ---- Changed lactation via button press, to "+lactNum+"                          ---- ##");
            }


            


            $s.loadReports = function loadReports() {
                var embed_small   = {width: 200,  // actions: false, //padding: 20,
                                     config: {
                                        actions: false, 
                                        legend: [], 
                                        axis: {labels: false, ticks: false},
                                        lactation_signal: {value: 3},
                                    } };

                var embed_large  = {actions: false, // {source: false, compiled: false, editor: showVegaEditor},
                                  tooltip: {theme: 'dark'} };

                function showError(el, error){
                    el.innerHTML = ('<div class="error">'
                        + '<p>JavaScript Error: ' + error.message + '</p>'
                        + "<p>This usually means there's a typo in your chart specification. "
                        + "See the javascript console for the full traceback.</p>"
                        + '</div>');
               
                    throw error;
                }

                vegaEmbed('#visSeasonalTrendsLactAll' , $s.dataLactAll  , embed_small).then((result) => { 
                  $s.sm_chart_all_lactations_view = result.view; 
                });
                vegaEmbed('#visSeasonalTrendsLact1'   , $s.dataLact1    , embed_small).then((result) => { 
                  $s.sm_chart_lactation1_view = result.view; 
                });
                vegaEmbed('#visSeasonalTrendsLact2'   , $s.dataLact2    , embed_small).then((result) => { 
                  $s.sm_chart_lactation2_view = result.view; 
                });

                vegaEmbed('#visSeasonalTrendsSelected', $s.chartSpec_lg , embed_large).then((result) => {
                  $s.currentLargeChartView = result.view;
                });

                console.log("## ---- vegaEmbed is complete                              ---- ##");
                
            };
      function cleanupVegaView(view, containerSelector) {
              if (!view) return;
              
              try {
                // 1. Remove all signal listeners - get all signal names from the view
                if (view._runtime && view._runtime.signals) {
                  Object.keys(view._runtime.signals).forEach(signalName => {
                    try {
                      // Remove all listeners for this signal
                      view.removeSignalListener(signalName, () => {});
                    } catch (e) {
                      // Signal listener might not exist, continue
                      console.warn(`Error removing signal listener for ${signalName}:`, e);
                    }
                  });
                }
                
                // 2. Remove event listeners if they exist
                if (view.removeEventListener) {
                  ['click', 'mouseover', 'mouseout', 'mousemove', 'touchstart', 'touchend'].forEach(event => {
                    try {
                      view.removeEventListener(event, () => {});
                    } catch (e) {
                      // Event listener might not exist, continue
                      console.warn(`Error removing event listener for ${event}:`, e);
                    }
                  });
                }
                
                // 4. Finalize the view (this should clean up internal references)
                view.finalize();
                
                // 5. Clean up the DOM container thoroughly
                if (containerSelector) {
                  const container = document.querySelector(containerSelector);
                  if (container) {
                    // First, remove all SVG elements specifically
                    const svgElements = container.querySelectorAll('svg');
                    svgElements.forEach(svg => {
                      // Clone and replace to remove all event listeners
                      const newSvg = svg.cloneNode(false); // shallow clone without children
                      svg.parentNode.replaceChild(newSvg, svg);
                      newSvg.remove();
                    });
                    
                    // Then clear everything else
                    container.innerHTML = '';
                  }
                }
                
              } catch (e) {
                console.warn(`Error cleaning up Vega view for ${containerSelector}:`, e);
              }
            }

            $s.$on("$destroy", function() {
                log.info("dashboard destroy called");
            
                deregOnHerdChange();
        
                $('.seasonal-trends-options-menu.dropdown-toggle').off('click');
                $('body').off('click');

              
                // Clean up all Vega views using the helper function
                cleanupVegaView($s.sm_chart_lactation1_view, '#visSeasonalTrendsLact1');
                cleanupVegaView($s.sm_chart_lactation2_view, '#visSeasonalTrendsLact2');
                cleanupVegaView($s.sm_chart_lactation_all_view, '#visSeasonalTrendsLactAll'); // Note: fixed variable name
                cleanupVegaView($s.currentLargeChartView, '#visSeasonalTrendsSelected');

                // null out all view references
                $s.sm_chart_lactation1_view = null;
                $s.sm_chart_lactation2_view = null;
                $s.sm_chart_lactation_all_view = null;
                $s.currentLargeChartView = null;

                // clean up data references
                $s.chartSpec_lg = null;
                $s.chartSpec_sm = null;
                $s.dataLact1 = null;
                $s.dataLact2 = null;
                $s.dataLactAll = null;
                $s.originalPythonSpecWithData = null;	

                $s.performanceContext = null;

            });

            MSF.ready(function onMsfReady() {

              $s.currentActiveHerd = MSF.getActiveHerd();
              $s.currentActiveFarm = MSF.getActiveFarm();
              $s.territoryManager  = MSF.getActiveFarmTerritoryManager(); 

              $s.herdId = _.get($s.currentActiveHerd,'herdId',_.get($s.currentActiveFarm,'herds[0].herdId'));

              setPythonFunctionUrl();

              $s.checkPermissions();

              if ($s.canViewPage == true) {
                $s.performanceContext = perfContextSvc.createPerformanceContext($s.herdId);
                perfMetricSvc.startTiming("Page:SeasonalTrends:Render");
                $s.loading = true;

                perfMetricSvc.startTiming("Page:SeasonalTrendsPageData:Request");
                api.post(pythonServicesFunctionUrl,{},JSON.stringify({HerdId: $s.herdId}),function(err,result){
                    perfMetricSvc.endTiming("page","Page:SeasonalTrendsPageData:Request", $s.performanceContext);
                    perfMetricSvc.startTiming("Page:SeasonalTrends:Build");
                    
                    $s.loading = false;
                    $s.originalPythonSpecWithData = result;
                    $s.buildAndEmbedReports();
                    $s.loadReports();
                    perfMetricSvc.endTiming("page","Page:SeasonalTrends:Build", $s.performanceContext);
                    perfMetricSvc.markPageReady("Page:SeasonalTrends:Render", $s.performanceContext);
                    console.log("## ---- Initial MSF.ready's buildAndEmbedReport & loadReports are complete ---- ##");
                  }
                )
              };

              deregOnHerdChange =   $s.$on('herd:changed', function(){
                $s.loading = false;
                
                $s.currentActiveHerd = MSF.getActiveHerd();
                $s.currentActiveFarm = MSF.getActiveFarm();
                $s.territoryManager  = MSF.getActiveFarmTerritoryManager(); 

                var dt = MSF.activeHerd.latestReportDate;
                $s.dataUpdatedDate = moment(dt).subtract(moment(dt).utcOffset(), 'minutes').format(MSF.i18n.format.dateLong);

                $s.herdId = _.get($s.currentActiveHerd,'herdId',_.get($s.currentActiveFarm,'herds[0].herdId'));

                setPythonFunctionUrl();

                $s.checkPermissions();

                if ($s.canViewPage == true) {
                  $s.performanceContext = perfContextSvc.createPerformanceContext($s.herdId);
                  perfMetricSvc.startTiming("Page:SeasonalTrendsOnHerdChange:Render");
                  $s.loading = true;

                  perfMetricSvc.startTiming("Page:SeasonalTrendsOnHerdChangePageData:Request");
                  api.post(pythonServicesFunctionUrl,{},JSON.stringify({HerdId: $s.herdId}),function(err,result){
                    perfMetricSvc.endTiming("page","Page:SeasonalTrendsOnHerdChangePageData:Request", $s.performanceContext);
                    perfMetricSvc.startTiming("Page:SeasonalTrendsOnHerdChange:Build");
                    $s.loading = false;
                    $s.originalPythonSpecWithData = result;
                    $s.buildAndEmbedReports();
                    $s.loadReports();
                    perfMetricSvc.endTiming("page","Page:SeasonalTrendsOnHerdChange:Build", $s.performanceContext);
                    perfMetricSvc.markPageReady("Page:SeasonalTrendsOnHerdChange:Render", $s.performanceContext);

                    console.log("## ---- Re-running with new HerdId buildAndEmbedReport & loadReports are complete ---- ##");
                  });
                };
                
              });

              // --- Options Menu to Stay Open instead of Dropdown's natural behavior, but Close when click outside of the Dropdown area ---
              var optionsToggleElm = $('.seasonal-trends-options-menu.dropdown-toggle').get(0);
              if(!_.isUndefined(optionsToggleElm)){
                  $('.seasonal-trends-options-menu.dropdown-toggle').on('click',function (event) {
                    console.log("opening tnt menu from Seasonal ")
                    $('.seasonal-trends-options-menu-container.dropdown').toggleClass('open');
                  });
              }else{
                var deregOptionsToggleElmWatch = $s.$watch(optionsToggleElm,function(newValue,oldValue,scope){
                    
                  var optionsToggleElm = $(".seasonal-trends-options-menu.dropdown-toggle").get(0);     
              
                  if(!_.isUndefined(optionsToggleElm)){
                    $('.seasonal-trends-options-menu.dropdown-toggle').on('click',function (event) {
                        console.log("opening tnt menu from Seasonal ")
                        $('.seasonal-trends-options-menu-container.dropdown').toggleClass('open');
                    });
                    deregOptionsToggleElmWatch();
                  }
                });
              }
              $('body').on('click', function (event) {
                  if (  !$('li.dropdown.seasonal-trends-options-menu-container').is(event.target) 
                      && $('li.dropdown.seasonal-trends-options-menu-container').has(event.target).length === 0 
                      && $('.open').has(event.target).length === 0
                  ) {
                        console.log("closing tnt menu from Seasonal ")
                        $('.seasonal-trends-options-menu-container.dropdown').removeClass('open');
                    }
                });

          });
            		 
		}
	]);
})();
